import { v4 as uuidv4 } from 'uuid';
import updateTaskDetailUseCase from './updateTaskDetailUseCase';
import { addFlagObservation } from 'tasks/api';

const addObservationUseCase = async (task, message, messageType) => {
    const details = task.detail[messageType] || []
    details.push({
        id: uuidv4(),
        message, 
        date: new Date().getTime()
    });

    task.detail[messageType] = details

    const { data, detail } = task
    await updateTaskDetailUseCase(data.id, detail)

    return addFlagObservation(data.id, true)
}

export default addObservationUseCase